import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

export default function Navbar(){
  const [open, setOpen] = useState(false);

  return (
    <nav className="nav">
      <div className="nav-inner">
        <div className="brand"><Link to="/">LIBERTY<span>Street</span></Link></div>
        <button className={open ? 'hamburger open' : 'hamburger'} onClick={() => setOpen(o => !o)} aria-label="Navigation öffnen">
          <span />
          <span />
          <span />
        </button>
        <ul className={open ? 'nav-links open' : 'nav-links'}>
          <li><Link to="/" onClick={() => setOpen(false)}>Home</Link></li>
          <li><Link to="/leistungen" onClick={() => setOpen(false)}>Leistungen</Link></li>
          <li><Link to="/speisekarte" onClick={() => setOpen(false)}>Speisekarte</Link></li>
          <li><Link to="/kontakt" onClick={() => setOpen(false)}>Kontakt</Link></li>
        </ul>
      </div>
    </nav>
  );
}
